import Vue from "vue";
import Router from "vue-router";
/* Layout */
import Layout from "@/layout";



Vue.use(Router);

/**
 * Note: 路由配置项
 *
 * hidden: true                   // 【重要】当设置 true 的时候该路由不会再侧边栏出现 如 401，login 等页面，或者如一些编辑页面 /edit/1
 * alwaysShow: true               // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * path: '/login',                // 【重要】访问的 URL 路径
 * component: Layout,             // 【重要】对应的组件；也可以是 (resolve) => require(['@/views/login'], resolve),
 * redirect: noRedirect           // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'             // 【重要】设定路由的名字，一定要填写不然使用 <keep-alive> 时会出现各种问题
 * meta : {
    noCache: true                // 【重要】如果设置为 true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'               // 【重要】设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'             // 【重要】设置该路由的图标，对应路径 src/assets/icons/svg
    breadcrumb: false            // 如果设置为 false，则不会在 breadcrumb 面包屑中显示
    activeMenu: '/system/user'   // 当路由设置了该属性，则会高亮相对应的侧边栏。
  }
 */

// 公共路由
export const constantRoutes = [
  {
    path: "/",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/",
        component: (resolve) => require(["@/views/home"], resolve),
      },
      {
        path: "/dynamics",
        meta: {
          title: '相关政策动态'
        },
        component: (resolve) => require(["@/views/dynamics"], resolve),
      },
      {
        path: "/dynamics/detail",
        component: (resolve) => require(["@/views/dynamics/detail.vue"], resolve),
        meta: {
          title: '相关政策动态详情'
        },
      }
    ],
  },
  {
    path: "/search",
    component: Layout,
    redirect: '/search/index',
    children: [
      {
        path: 'index',
        name: "searchIndex",
        meta: {
          title: '搜索'
        },
        component: (resolve) =>
          require(["@/views/search/index.vue"], resolve),
      }
    ]
  },
  {
    path: "/expertise",
    component: Layout,
    children: [
      {
        path: "list",
        meta: {
          title: '专业能力'
        },
        redirect: '/expertise/list/technical',
        component: (resolve) =>
          require(["@/views/expertise/list.vue"], resolve),
        children: [
          {
            path: "technical",
            meta: {
              title: '技术方向'
            },
            component: (resolve) =>
              require(["@/views/expertise/technical.vue"], resolve),
          },
          {
            path: "resource",
            meta: {
              title: '配套资源'
            },
            component: (resolve) =>
              require(["@/views/expertise/resource.vue"], resolve),
          }
        ]
      },
      {
        path: "list/detail",
        meta: {
          title: '详情'
        },
        component: (resolve) =>
          require(["@/views/expertise/detail.vue"], resolve),
      }
    ]
  },
  {
    path: "/service",
    component: Layout,
    children: [
      {
        path: "list",
        meta: {
          title: '服务能力'
        },
        component: (resolve) =>
          require(["@/views/service/list.vue"], resolve)
      },
      {
        path: "cora",
        meta: {
          title: '服务能力'
        },
        component: (resolve) =>
          require(["@/views/service/cora.vue"], resolve),
      },
      {
        path: 'coralist/:type',
        meta: {
          title: '列表'
        },
        component: (resolve) =>
          require(["@/views/service/coralist.vue"], resolve),
      },
      {
        path: 'coradetail/:type',
        meta: {
          title: '详情'
        },
        component: (resolve) =>
          require(["@/views/service/coradetail.vue"], resolve),
      }
    ]
  },
  {
    path: "/information",
    component: Layout,
    children: [
      {
        path: 'list',
        meta: {
          title: '信息公开'
        },
        redirect: '/information/list/INFOS_1',
      },
      {
        path: 'list/:code',
        name: 'informationListCode',
        component: (resolve) =>
          require(["@/views/information/list.vue"], resolve),
        children: [
          {
            path: 'detail',
            name: 'informationListDetail',
            component: (resolve) =>
              require(["@/views/information/detail.vue"], resolve),
          }
        ]
      }
    ],
  },
  {
    path: "/party",
    component: Layout,
    children: [
      {
        path: "building",
        meta: {
          title: '党建'
        },
        component: (resolve) =>
          require(["@/views/party/building.vue"], resolve),
        children: [
          {
            path: "list",
            meta: {
              title: '列表'
            },
            component: (resolve) =>
              require(["@/views/party/list.vue"], resolve),
          },
          {
            path: "detail",
            meta: {
              title: '详情'
            },
            component: (resolve) =>
              require(["@/views/party/detail.vue"], resolve),
          },
        ],
      },
    ],
  },
  {
    path: "/about",
    component: Layout,
    children: [
      {
        path: "list",
        meta: {
          title: '关于达安'
        },
        component: (resolve) => require(["@/views/about/list.vue"], resolve),
        children: [
          {
            path: "expert",
            meta: {
              title: '专家团队'
            },
            component: (resolve) =>
              require(["@/views/about/expert.vue"], resolve),
          },
          {
            path: "organizational",
            meta: {
              title: '组织架构'
            },
            component: (resolve) =>
              require(["@/views/about/organizational.vue"], resolve),
          },
          {
            path: "lead",
            meta: {
              title: '领导团队'
            },
            component: (resolve) =>
              require(["@/views/about/lead.vue"], resolve),
          },
          {
            path: "enterprise",
            meta: {
              title: '事业布局'
            },
            component: (resolve) =>
              require(["@/views/about/enterprise.vue"], resolve),
          },
          {
            path: "service",
            meta: {
              title: '服务理念'
            },
            component: (resolve) =>
              require(["@/views/about/service.vue"], resolve),
          },
          {
            path: "hr",
            meta: {
              title: '人力资源'
            },
            component: (resolve) =>
              require(["@/views/about/hr.vue"], resolve),
            children: [
              {
                path: "detail",
                meta: {
                  title: '活动详情'
                },
                component: (resolve) =>
                  require(["@/views/about/detail.vue"], resolve),
              },
              {
                path: "post",
                meta: {
                  title: '招聘岗位'
                },
                component: (resolve) =>
                  require(["@/views/about/post.vue"], resolve),
              },
              {
                path: "hrdetail",
                meta: {
                  title: '岗位详情'
                },
                component: (resolve) =>
                  require(["@/views/about/hrdetail.vue"], resolve),
              }
            ]
          }
        ],
      },
    ],
  },
  {
    path: "/news",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "list",
        meta: {
          title: '新闻资讯'
        },
        component: (resolve) => require(["@/views/news/list.vue"], resolve),
        children: [
          {
            path: "hot",
            meta: {
              title: '热点新闻'
            },
            component: (resolve) => require(["@/views/news/hot.vue"], resolve),
          },
          {
            path: "standard",
            meta: {
              title: '标准新闻'
            },
            component: (resolve) => require(["@/views/news/standard.vue"], resolve),
          },
          {
            path: "culture",
            meta: {
              title: '企业文化'
            },
            component: (resolve) =>
              require(["@/views/news/culture.vue"], resolve),
          },
          {
            path: "technology",
            meta: {
              title: '技术交流'
            },
            component: (resolve) =>
              require(["@/views/news/technology.vue"], resolve),
          },
          {
            path: "detail",
            meta: {
              title: '详情'
            },
            component: (resolve) =>
              require(["@/views/news/detail.vue"], resolve),
          },
        ],
      },
    ],
  },

  {
    path: "*",
    name: "PageNotFound",
    alias: '/PageNotFound/',
    component: (resolve) => require(["@/views/error/404"], resolve),
    hidden: true,
  },
  {
    path: "/401",
    component: (resolve) => require(["@/views/error/401"], resolve),
    hidden: true,
  }
];

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err);
};

var router = new Router({
  base: process.env.VUE_APP_APP_NAME ? process.env.VUE_APP_APP_NAME : "/",
  mode: "history", // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});

router.beforeEach((to, from, next) => {

  next((vm) => {
    console.log(vm, 'vm=============')
  });
});


export default router
